import React from "react";

//Styles
import "./PageLanding.scss";

//Components
import Header from "./sections/Header/Header";
import Cover from "./sections/Cover/Cover";
import Squares from "./sections/Squares/Squares";
import SeeOur from "./sections/SeeOur/SeeOur";
import HowItWorks from "./sections/HowItWorks/HowItWorks";
import Feedback from "./sections/Feedback/Feedback";
import NeedMore from "./sections/NeedMore/NeedMore";
import WhyDesignContest from "./sections/WhyDesignContest/WhyDesignContest";
import ByIndustry from "./sections/ByIndustry/ByIndustry";
import Questions from "./sections/Questions/Questions";
import NeedMoreHelp from "./sections/NeedMoreHelp/NeedMoreHelp";
import Footer from "./sections/Footer/Footer";

function landing() {
  return (
    <main className="page-landing">
      <div className="cover-gradient">
        <Header />
        <Cover />
        <Squares />
      </div>
      <SeeOur />
      <HowItWorks />
      <Feedback />
      <NeedMore />
      <WhyDesignContest />
      <ByIndustry />
      <Questions />
      <NeedMoreHelp />
      <Footer />
    </main>
  );
}

export default landing;
